module.exports = __webpack_public_path__ + "img/img_celebrate.be34d34d.svg";